// extracted by mini-css-extract-plugin
module.exports = {"heartSymbol":"FavoriteStations-module__heartSymbol___2xsYw"};